import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { Card, CardHeader, CardContent } from '../../components/ui/Card';
import { CheckCircle } from 'lucide-react';

const AssessmentComplete = () => {
  const { theme } = useTheme();

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12" style={{ backgroundColor: theme.surface }}>
      <div className="max-w-2xl w-full">
        <Card>
          <CardHeader>
            <div className="flex items-center gap-3 justify-center mb-4">
              <div className="w-16 h-16 rounded-full flex items-center justify-center" style={{ backgroundColor: `${theme.primary}20` }}>
                <CheckCircle className="w-8 h-8" style={{ color: theme.primary }} />
              </div>
            </div>
            <h1 className="text-3xl font-bold text-center" style={{ color: theme.text }}>
              Assessment Complete!
            </h1>
          </CardHeader>

          <CardContent>
            <div className="text-center space-y-4">
              <p className="text-lg" style={{ color: theme.textSecondary }}>
                Thank you for completing your investment assessment.
              </p>
              <div className="p-6 rounded-lg" style={{ backgroundColor: theme.surface, border: `1px solid ${theme.border}` }}>
                <p className="text-sm" style={{ color: theme.textSecondary }}>
                  Your advisor will review your responses and discuss the recommended investment strategy with you. You may now close this page.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AssessmentComplete;
